import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { confirmDialog } from 'primereact/confirmdialog';
import { Column } from 'primereact/column';
import { useLazyParams } from '../../../../hooks/useLazyParams';
import { InputComponent } from '../../../../components/InputComponent';
import { TablaDinamica } from '../../../../components/TablaDinamica';
import * as generic from '../../../../components/Generico';
import { DetalleCliente } from '../../../../models/trust/proveedor/DetalleCliente';
import { DetalleClienteService } from '../../../../service/trust/DetalleClienteService';

export const ClientePrincipal = ({ toast, id, tipo, catalogos, permss, soloLectura }) => {
    // Inicialización
    const omodel = new DetalleCliente();
    const defaultValues = generic.funDefault(omodel.model, null);
    // Estados principales
    const [dialogCliente, setDialogCliente] = useState(false);
    const [clienteSeleccionado, setclienteSeleccionado] = useState(null);
    const menuRef = useRef(null);
    // Estados de lógica del formulario
    const [esRuc, setEsRuc] = useState(false);
    const [esCedula, setEsCedula] = useState(false);
    // Servicios y Hooks
    const clienteSrv = new DetalleClienteService();
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, clearErrors } = useForm({ defaultValues });
    const { inDrop, inText, inCalendar } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    // Cargar datos de la tabla cuando cambien los parámetros o el id
    useEffect(() => {
        if (id) {
            loadLazyData();
        }
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams, id]);

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        _lazyParams.idp = id;
        _lazyParams.tipo = tipo;
        clienteSrv.getLista({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    };

    const openNew = () => {
        setEsRuc(false); setEsCedula(false);
        reset(defaultValues);
        setDialogCliente(true);
    };

    const hideDialog = () => setDialogCliente(false);

    const onSubmit = (data) => {
        data.idp = id;
        data.tipo = tipo;
        data.cliente_desde = generic.dateToString(data.cliente_desde);

        const request = getValues('id') == null ? clienteSrv.nuevo(data) : clienteSrv.editar(data);

        request.then(res => {
            setDialogCliente(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        });
    };

    const editDeclarante = (idCliente) => {
        clienteSrv.consultar(idCliente).then(res => {
            let _cli = res.data.cliente;
            setEsRuc(_cli.tipo_identificacion?.cat_id === catalogos?.ruc?.cat_id);
            setEsCedula(_cli.tipo_identificacion?.cat_id === catalogos?.cedula?.cat_id);
            _cli.cliente_desde = generic.stringToDate(_cli.cliente_desde);
            reset(generic.renewValues(_cli, omodel.model));
            setDialogCliente(true);
        });
    };

    const confirmDelete = (idCliente) => {
        confirmDialog({
            message: '¿Está seguro de eliminar el declarante?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                clienteSrv.delete(idCliente).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    };

    const onChangeTipo = (e) => {
        setEsRuc(JSON.stringify(e.value) === JSON.stringify(catalogos.ruc));
        setEsCedula(JSON.stringify(e.value) === JSON.stringify(catalogos.cedula));
        clearErrors('identificacion');
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{
                label: 'Opciones',
                items: [
                    { label: 'Ver detalle', icon: 'pi pi-eye', command: () => editDeclarante(clienteSeleccionado?.id) }
                ]
            }];
        }

        // Opciones estandar
        return [{
            label: 'Opciones',
            items: [
                { label: 'Editar', icon: 'pi pi-pencil', command: () => editDeclarante(clienteSeleccionado?.id) },
                { label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(clienteSeleccionado?.id) }
            ]
        }];
    };

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup
            onClick={(event) => { setclienteSeleccionado(rowData); menuRef.current.toggle(event); }}
        />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => {
        return (
            <div className="flex align-items-center justify-content-start gap-3 py-1">
                {permss?.crear && id && !soloLectura && (
                    <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
                )}
                <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                    Listado de Clientes
                </span>
            </div>
        );
    };
    const tipoDoc = esRuc ? 'IDEN_RUC' : esCedula ? 'IDEN_CEDULA' : null;

    const reglaValidacion = (val) => {
        // Si no es RUC ni Cédula (ej. Análogo u otros), es válido por defecto
        if (!tipoDoc) return true;
        return generic.validarIdentificacionEcuador(val, tipoDoc) || `${esRuc ? 'RUC' : 'Cédula'} incorrecto`;
    };

    return (
        <div className="componente-declarante">
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />
            <Dialog visible={dialogCliente} header={getValues('id') == null ? "Nuevo cliente" : "Editar cliente"} modal className="p-fluid modal-ssize dialog-personalizado" onHide={hideDialog} style={{ width: '450px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid px-2">

                        <div className="col-12 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-user text-primary"></i>
                                    DETALLE DE PRINCIPALES CLIENTES:
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        {inText('nombre_completo', { icon: 'pi pi-user' }, 12)}
                        {inDrop('tipo_identificacion', catalogos?.tipo_identificacion, { lab: 'nombre', chn: onChangeTipo }, 12)}
                        {inText('identificacion', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 12)}
                        {inText('telefono', { icon: 'pi pi-phone' }, 12)}
                        {inCalendar('cliente_desde', {}, 12)}

                        <div className="col-12 mt-4 flex justify-content-end">
                            {soloLectura ? (
                                <div className="field col">
                                    <Button label="Cerrar" style={{ maxWidth: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={() => hideDialog(false)} />
                                </div>
                            ) : (
                                generic.buttonsForms(hideDialog)
                            )}
                        </div>

                    </div>
                </form>
            </Dialog>
        </div>
    );
};